import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ChevronDown } from "lucide-react";

// Shows a "Scroll down" cue whenever more of the page is hidden below the screen
export default function ScrollCue() {
  const [show, setShow] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => {
    const check = () => {
      const below = document.documentElement.scrollHeight - (window.scrollY + window.innerHeight);
      setShow(window.scrollY < 120 && below > 240);
    };
    const t = setTimeout(check, 900);
    window.addEventListener("scroll", check, { passive: true });
    window.addEventListener("resize", check);
    return () => { clearTimeout(t); window.removeEventListener("scroll", check); window.removeEventListener("resize", check); };
  }, [pathname]);
  return (
    <button type="button" aria-label="Scroll down to see more" data-testid="scroll-down-cue"
      onClick={() => window.scrollBy({ top: window.innerHeight * 0.8, behavior: "smooth" })}
      className={`fixed bottom-5 left-1/2 -translate-x-1/2 z-40 inline-flex items-center gap-2 rounded-full bg-lou-ink/90 text-lou-paper text-xs tracking-wide px-4 py-2.5 shadow-lg backdrop-blur transition-[opacity,transform] duration-500 ${show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3 pointer-events-none"}`}>
      Scroll down <ChevronDown size={15} className="lou-bob" />
    </button>
  );
}
